import React from 'react'
import TileNavigation from './TileNavigation'
import DreamBlock from './DreamBlock'

enum Variant {
  TileNavigation = 'Tile Navigation',
  DreamBlock = 'Dream Block',
}

interface Props {
  title: string
  tiles: Array<App.HubTile>
  maxTilesVisible: number
  variant?: Variant
}

function AdditionalGuides(props: Props) {
  const { variant = Variant.TileNavigation } = props
  return <>
    {variant === Variant.TileNavigation && <TileNavigation {...props} />}
    {variant === Variant.DreamBlock && <DreamBlock {...props} />}
  </>
}

export default AdditionalGuides
